var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Protect-policy-home-main",class:{ 'Protect-policy-home-main-mobile': _vm.isMobile}},[_c('Base-title',{attrs:{"title":"隐私政策"}}),_c('PolicyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }